module.exports = __webpack_public_path__ + "static/img/3117-01.de42e361.jpg";